import React from 'react';
import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import Button from '../button';
import './style.scss';
import type { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';

type Props = {
  bodyText?: string,
  buttonIcon?: FontAwesomeIconProps,
  buttonText?: string,
  header?: string,
  icon?: IconProp,
  iconSize?: SizeProp,
  style?: React.CSSProperties,
  onClick?: () => void
}

export default function EmptyState({
  bodyText,
  buttonIcon,
  buttonText,
  header,
  icon,
  iconSize = '4x',
  style,
  onClick
}: Props) {
  return (
    <div
      className="ds-empty-state gap-4 d-flex flex-column align-items-center justify-content-center w-100 h-100 p-4"
      style={style || {}}
    >
      {icon ? (
        <FontAwesomeIcon className="icon-gradient" icon={icon} size={iconSize}/>
      ) : null}
      {header ? (<h3 className="m-0 text-center"><strong>{header}</strong></h3>) : null}
      {bodyText ? (<div className="ds-text-muted">{bodyText}</div>) : null}
      {buttonText && onClick ? (
        <Button.Secondary icon={buttonIcon} plain type="button" onClick={onClick}>{buttonText}</Button.Secondary>
      ) : null}
    </div>
  );
}
